import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { Filter } from "~/features/filter";
import { subdivisionFilterFields } from "~/widgets/Filter/SubdivisionFilter/model/fields";

export const SubdivisionFilter = () => {
  const { t } = useTranslation();
  const fields = useMemo(() => subdivisionFilterFields(t), [t]);

  return <Filter.Root fields={fields} alwaysShow columns={4} />;
};
